if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);

      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );

        this.lojaFisicaMode =
          new URLSearchParams(window.location.search).get("from_loja_fisica") === "1";
        this.lojaFisicaAvailabilityMap = {};
        this.lojaFisicaReady = false;
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      async initialize() {
        if (this.lojaFisicaMode) {
          await this.loadLojaFisicaAvailability();
        }

        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();

        if (this.lojaFisicaMode) {
          this.applyLojaFisicaVisibility();
          this.ensureValidSelectionForLojaFisica();
          this.updateOptions();
          this.updateMasterId();
          this.updateGallery();
          this.updateVariantStatuses();

          if (this.currentVariant) {
            this.updateMedia();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
          } else {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
          }
        }
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
        }
      }

      onVariantChange() {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);

        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (this.lojaFisicaMode) {
          this.applyLojaFisicaVisibility();
          this.ensureValidSelectionForLojaFisica();
          this.updateOptions();
          this.updateMasterId();
          this.updateGallery();
          this.updateVariantStatuses();
        }

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }

        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      async loadLojaFisicaAvailability() {
        const variants = this.getVariantData() || [];
        const requests = variants.map((variant) => {
          const variantId = String(variant.id);

          return fetch(`/apps/api?variant_id=${variantId}`, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Cache-Control": "no-cache",
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
              }
              return response.json();
            })
            .then((data) => {
              const inStock = Boolean(
                data &&
                  data.success === true &&
                  data.inventory &&
                  data.inventory.in_stock === true &&
                  Number(data.inventory.available) > 0,
              );

              this.lojaFisicaAvailabilityMap[variantId] = inStock;
            })
            .catch(() => {
              this.lojaFisicaAvailabilityMap[variantId] = false;
            });
        });

        await Promise.all(requests);
        this.lojaFisicaReady = true;
      }

      getAvailableVariantData() {
        const variants = this.getVariantData() || [];

        if (!this.lojaFisicaMode || !this.lojaFisicaReady) {
          return variants.filter((variant) => variant.available === true);
        }

        return variants.filter((variant) => {
          return this.lojaFisicaAvailabilityMap[String(variant.id)] === true;
        });
      }

      applyLojaFisicaVisibility() {
        if (!this.lojaFisicaMode) return;

        const availableVariants = this.getAvailableVariantData();
        const inputWrappers = [...this.querySelectorAll(".product-form__input")];

        inputWrappers.forEach((optionWrapper, optionIndex) => {
          const optionInputs = [
            ...optionWrapper.querySelectorAll('input[type="radio"], option'),
          ];

          optionInputs.forEach((input) => {
            const value =
              input.tagName === "OPTION"
                ? input.value
                : input.getAttribute("value");

            const matchesAnyAvailableVariant = availableVariants.some(
              (variant) => variant[`option${optionIndex + 1}`] === value,
            );

            const label =
              input.tagName === "OPTION"
                ? null
                : this.querySelector(`label[for="${input.id}"]`);

            const listItem =
              input.tagName === "OPTION" ? null : input.closest("li");

            if (matchesAnyAvailableVariant) {
              if (input.tagName === "OPTION") {
                input.hidden = false;
                input.disabled = false;
              } else {
                input.disabled = false;
                input.classList.remove("disabled");
              }

              if (label) {
                label.classList.remove("disabled");
                label.style.display = "";
              }

              if (listItem) {
                listItem.style.display = "";
              }
            } else {
              if (input.tagName === "OPTION") {
                input.hidden = true;
                input.disabled = true;
                if (input.selected) input.selected = false;
              } else {
                input.disabled = true;
                input.checked = false;
                input.classList.add("disabled");
              }

              if (label) {
                label.classList.add("disabled");
                label.style.display = "none";
              }

              if (listItem) {
                listItem.style.display = "none";
              }
            }
          });
        });
      }

      ensureValidSelectionForLojaFisica() {
        if (!this.lojaFisicaMode) return;

        const availableVariants = this.getAvailableVariantData();
        if (!availableVariants.length) return;

        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );

        fieldsets.forEach((fieldset, index) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          const checkedInput = inputs.find(
            (input) => input.checked && !input.disabled,
          );

          if (checkedInput) return;

          let candidates = availableVariants;

          for (let prevIndex = 0; prevIndex < index; prevIndex++) {
            const previousChecked = fieldsets[prevIndex].querySelector(
              'input[type="radio"]:checked',
            );
            if (previousChecked) {
              candidates = candidates.filter(
                (variant) =>
                  variant[`option${prevIndex + 1}`] === previousChecked.value,
              );
            }
          }

          const validValues = candidates
            .map((variant) => variant[`option${index + 1}`])
            .filter(Boolean);

          const fallbackInput = inputs.find(
            (input) =>
              !input.disabled &&
              validValues.includes(input.value),
          );

          if (fallbackInput) {
            fallbackInput.checked = true;
          }
        });
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value;
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index] || "";
          const titleValue = fieldset.querySelector(
            ".wt-product__option__title .value",
          );
          if (titleValue) titleValue.innerHTML = selectedOption;

          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdown) dropdown.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("variant", this.currentVariant.id);

        if (this.lojaFisicaMode) {
          currentUrl.searchParams.set("from_loja_fisica", "1");
        }

        window.history.replaceState({}, "", currentUrl.toString());
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;

        let shareUrl = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
        if (this.lojaFisicaMode) {
          shareUrl += "&from_loja_fisica=1";
        }

        shareButton.updateUrl(shareUrl);
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        const availableVariants = this.getAvailableVariantData();
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];

        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;

          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];

          let availableOptionInputsValue = [];

          if (index === 0) {
            availableOptionInputsValue = availableVariants.map(
              (variant) => variant.option1,
            );
          } else {
            const previousSelections = [];
            for (let i = 0; i < index; i++) {
              const selectedValue =
                inputWrappers[i]?.querySelector(":checked")?.value;
              previousSelections.push(selectedValue);
            }

            availableOptionInputsValue = availableVariants
              .filter((variant) => {
                return previousSelections.every((selectedValue, prevIndex) => {
                  return variant[`option${prevIndex + 1}`] === selectedValue;
                });
              })
              .map((variantOption) => variantOption[`option${index + 1}`]);
          }

          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          const value =
            input.tagName === "OPTION"
              ? input.value
              : input.getAttribute("value");

          if (listOfAvailableOptions.includes(value) && !input.disabled) {
            input.classList.remove("disabled");
          } else if (!listOfAvailableOptions.includes(value)) {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            if (this.currentVariant?.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`,
            );
            const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`,
            );
            const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`,
            );

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden"),
              );
            }

            const price = document.getElementById(
              `price-${this.dataset.section}`,
            );

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === "",
              );

            const addButtonUpdated = html.getElementById(
              `ProductSubmitButton-${sectionId}`,
            );
            this.toggleAddButton(
              addButtonUpdated
                ? addButtonUpdated.hasAttribute("disabled")
                : true,
              window.variantStrings.soldOut,
            );
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }
    },
  );
}